import _ from 'lodash';

import { RECEIVED_GLOBAL_SETTINGS, MERGE_GLOBAL_SETTING_IN_STORE } from '../../actions/settings';

export default (state = {}, { type, payload }) => {
  switch (type) {
    case RECEIVED_GLOBAL_SETTINGS:
      return _.assign({}, state, payload);

    case MERGE_GLOBAL_SETTING_IN_STORE:
      return _.assign({}, state, payload);

    default:
      return state;
  }
};
